export default class SkuMapping {
    thirdPartySku: string;
    productSku: string;
    id: number;
}